import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      setError('Failed to sign out. Please try again.');
      console.error('Sign out error:', error);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="welcome-message">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div className="dashboard-container">
      {error && (
        <div className="error-message" style={{ color: 'red', marginBottom: '20px' }}>
          {error}
        </div>
      )}
      <div className="welcome-message">
        <h1>Laipni lūgti DundagAI</h1>
        <p>Tavs portāls uz modernu lauku vidi</p>
        
        <div className="user-info" style={{ marginTop: '20px' }}>
          <p>Logged in as: {user.email}</p>
          <button 
            onClick={handleSignOut}
            style={{
              padding: '10px 20px',
              marginTop: '10px',
              cursor: 'pointer',
              backgroundColor: '#ff4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
